import { render, staticRenderFns } from "./JournalReturnMRView.vue?vue&type=template&id=26ed4e8c"
import script from "./JournalReturnMRView.vue?vue&type=script&lang=js"
export * from "./JournalReturnMRView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports